import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=d9b3f560&scoped=true&"
import script from "./SectionCard.vue?vue&type=script&lang=ts&"
export * from "./SectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./SectionCard.vue?vue&type=style&index=0&id=d9b3f560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b3f560",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VListItem,VListItemContent,VListItemTitle})
